import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[wlProgressiveFormSummary]',
  standalone: true,
})
export class ProgressiveFormSummaryDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
